import * as yup from 'yup';

import { Row, RenderConfig, DateRangeInput, SelectInput, MIN_DATE, MAX_DATE, MIN_DATE_OBJECT, MAX_DATE_OBJECT } from 'commons-ui';
import { NINETY_DAYS_IN_MS } from 'constant';
import { TRANSACTION_TYPE_OPTIONS } from '../../constant';

const FORM_FIELD_KEYS = {
	DATE_RANGE: 'dateRange',
	TRANSACTION_TYPES: 'transactionTypes'
};

export const validationSchema = yup.object().shape({
	dateRange: yup
		.array()
		.test({
			message: 'Date Range should be maximum of 90 days',
			test: (value: any) => value[1] - value[0] <= NINETY_DAYS_IN_MS
		})
		.test({
			message: `"from" date must be in a range of ${MIN_DATE} to ${MAX_DATE}`,
			test: (value: any) => value.length === 0 || (value[0] >= MIN_DATE_OBJECT && value[0] <= MAX_DATE_OBJECT)
		})
		.test({
			message: `"To" date must be in a range of ${MIN_DATE} to ${MAX_DATE}`,
			test: (value: any) => value.length === 0 || (value[1] >= MIN_DATE_OBJECT && value[1] <= MAX_DATE_OBJECT)
		}),
	transactionTypes: yup.number()
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.DATE_RANGE]: new RenderConfig()
		.setName('dateRange')
		.setLabel('Date Range')
		.setRenderer(DateRangeInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			placeholder: 'From-To Date',
			required: true
		}),
	[FORM_FIELD_KEYS.TRANSACTION_TYPES]: new RenderConfig()
		.setName('transactionTypes')
		.setLabel('Transaction Types')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: TRANSACTION_TYPE_OPTIONS
			// multi: true
			// creatable: true
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.DATE_RANGE), new Row(FORM_FIELD_KEYS.TRANSACTION_TYPES)];
